<template>
  <div v-if="sail != null">
    <div class="modal-popup">
      <div class="modal fade" id="cabinViewPopup" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title title" id="exampleModalLongTitle4">Kat Planı</h5>
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="la la-close"></span>
              </button>
            </div>
            <div class="modal-body" v-if="sail != null">
              <img v-for="deck in sail.cruise.decks" v-if="checkShow(deck)" :src="deck.imageUrl" alt="" class="w-100">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cabinViewPopup",
  computed:{
    sail:{
      get(){
        return this.$store.getters.getSail;
      }
    },
    popupSelectedRoom:{
      get(){
        return this.$store.getters.getPopupSelectedRoom;
      }
    },
  },
  methods:{
    checkShow(deck){
      let theArray = [];
      if(this.popupSelectedRoom == null){
        return false;
      }
      for(let i = 0;i<this.popupSelectedRoom.cruiseRooms.length;i++){
        let cruiseRoom = this.popupSelectedRoom.cruiseRooms[i];
        // if (cruiseRoom !== undefined){
          theArray.push(cruiseRoom.deckId)
        // }
      }
      // theArray = theArray.filter(function(item, pos) {
      //   return theArray.indexOf(item) == pos;
      // })

      return theArray.includes(deck.id);
    }
  }
}
</script>

<style scoped>

</style>